import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import blogimag from '../Assets/Logo/Blue Logo with BG.png'

const API = "https://growthloomdigital.com/api";

const Blog = () => {
  const navigate = useNavigate();

  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchBlogs = async () => {
    try {
      const res = await fetch(`${API}/getBlogs.php`, {
        method: "POST",
      });

      const data = await res.json();

      if (data.status === "success") {
        setBlogs(data.data);
      } else {
        setBlogs([]);
      }

    } catch (error) {
      console.log(error);
      setBlogs([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  return (
    <div className="w-full px-4 sm:px-6 lg:px-12 py-10 bg-gray-100 mt-[10%]">

      {/* Heading */}
      <div className="text-center mb-8">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-800">
          Our Latest Blog
        </h2>

        <p className="text-gray-500 mt-2 text-sm sm:text-base">
          Insights, tips & strategies to grow your business
        </p>

        <div className="w-20 h-1 bg-[#f99728] mx-auto mt-3 rounded-full"></div>
      </div>

      {/* Loading */}
      {loading && (
        <p className="text-center text-gray-500">Loading blogs...</p>
      )}

      {/* Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">

        {blogs.map((blog) => (
          <div
            key={blog.id}
            className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition duration-300 border border-[#f99728]"
          >

            {/* Image */}
            <div className="overflow-hidden">

              <img
                src={blog.image1 ? blog.image1 : blogimag}
                alt="blog"
                className="w-full h-48 sm:h-52 md:h-56 object-cover hover:scale-105 transition duration-300"
              />

            </div>

            {/* Content */}
            <div className="p-4 sm:p-5 flex flex-col justify-between h-[200px]">

              <p className="text-gray-500 text-sm mb-2">
                📅 {blog.created_at}
              </p>

              <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-3 line-clamp-3">
                {blog.title}
              </h3>

              {/* Button */}
              <button
                // onClick={() => navigate("/contact")}
                onClick={() => navigate(`/blog/${blog.id}`)}
                className="bg-[#f99728] text-white px-4 py-2 rounded-md w-fit hover:bg-yellow-500 transition"
              >
                Read More
              </button>

            </div>

          </div>
        ))}

      </div>
    </div>
  );
};

export default Blog;